// It can be used in both get / post call
// Only properties of body will be differnt
export const digitalInspectionReportDetails = `
  mutation digitalInspectionReportDetails(
    $body: AWSJSON!
  ) {
    generateDIReport(body: $body)
  }
`

// Mutation for multi DI reports
export const digitalInspectionReportDetailsMulti = `
  mutation digitalInspectionReportDetails(
    $body: AWSJSON!
  ) {
    generateDISumary(body: $body)
  }
`

export const updateEquipmentProperty = `
  mutation UPDATE_EQUIPMENT_PROPERTY($input:UpdateEquipmentPropertyInput!) {
    updateEquipmentProperty(input: $input) {
      id
      tisDisplayName
      value
      creationType
    }
  }
`

export const createReportSetting = `
  mutation createReportSetting($input: CreateReportSettingInput!) {
    createReportSetting(input: $input) {
      id
      filePath
      userData
      schedulerData
      status
    }
  }
`

export const updateReportSetting = `
  mutation updateReportSetting($input: UpdateReportSettingInput!) {
    updateReportSetting(input: $input) {
      id
      filePath
      userData
      schedulerData
      status
    }
  }
`

